import { render, staticRenderFns } from "./usappbktutorverin.vue?vue&type=template&id=21625a2b&scoped=true&"
import script from "./usappbktutorverin.vue?vue&type=script&lang=js&"
export * from "./usappbktutorverin.vue?vue&type=script&lang=js&"
import style0 from "./usappbktutorverin.vue?vue&type=style&index=0&id=21625a2b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "21625a2b",
  null
  
)

export default component.exports